/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `pairs` - Dobieranie par
 * * `trueFalse` - Prawda/Fałsz
 * * `singleChoice` - Jednokrotny wybór
 */
export type QuizQuestionTypeEnum = typeof QuizQuestionTypeEnum[keyof typeof QuizQuestionTypeEnum];


export const QuizQuestionTypeEnum = {
  pairs: 'pairs',
  trueFalse: 'trueFalse',
  singleChoice: 'singleChoice',
} as const;
